import { registerToolRenderers } from "@bastion/assistant";
import { ChoiceCard } from "./ChoiceCard";
import { InlineWorkflowResults } from "./InlineWorkflowResults";

let registered = false;

/**
 * Register the webapp's custom tool renderers exactly once. Mirrors the
 * `registerWebToolExecutors` pattern in `@/app/assistantTools` so all
 * assistant-facing wiring is initialized from a single AppLayout effect.
 */
export function registerWebToolRenderers(): void {
  if (registered) {
    return;
  }
  registered = true;
  registerToolRenderers({
    ask_user_choice: ChoiceCard,
    render_workflow_results: InlineWorkflowResults,
  });
}
